import { FlexBox, Table } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';

import { AvatarPlaceholder } from '../../placeholders/avatarPlaceholder/avatarPlaceholder';
import { TextPlaceholder } from '../../placeholders/textPlaceholder/textPlaceholder';

export type ConversationsTableConversationPlaceholderRowsProps = {
  amount?: number;
};

export const ConversationsTableConversationPlaceholderRows = ({
  amount = 20,
}: ConversationsTableConversationPlaceholderRowsProps): JSX.Element => {
  return (
    <>
      {Array.from(Array(amount)).map((_, index) => (
        <Table.Tr key={index}>
          <Table.Td height="65px">
            <TextPlaceholder height="24px" borderRadius="100" />
          </Table.Td>

          <Table.Td>
            <FlexBox gap={sizes.spacer['300']} alignItems="center">
              <AvatarPlaceholder />
              <TextPlaceholder width="60%" />
            </FlexBox>
          </Table.Td>

          <Table.Td>
            <TextPlaceholder width="60%" />
          </Table.Td>

          <Table.Td>
            <TextPlaceholder width="50%" />
          </Table.Td>

          <Table.Td>
            <TextPlaceholder width="60%" />
          </Table.Td>

          <Table.Td>
            <FlexBox gap="16px" alignItems="center">
              <AvatarPlaceholder />
              <TextPlaceholder width="50%" />
            </FlexBox>
          </Table.Td>

          <Table.Td>
            <TextPlaceholder width="80%" />
          </Table.Td>

          <Table.Td>
            <TextPlaceholder width="80%" />
          </Table.Td>

          <Table.Td />
        </Table.Tr>
      ))}
    </>
  );
};
